module.exports = __webpack_public_path__ + "media/recipes/42-54bda427.png";